// Generated by tools/animation/extract_secondary_motion_handler_evidence.py.
// Pinned 1ST_READ.BIN; see tools/evidence/shenmue1-secondary-motion-handlers.json.
export const NATIVE_CONTROLLED_SURFACE_PROFILE = Object.freeze({
  "activationThreshold": 9.999999974752427e-07,
  "childScaleBase": 0.19999998807907104,
  "childScaleRetention": 0.7999999523162842,
  "fixedTurnUnitsPer45Degrees": 8192.0
});
